import { configureStore } from '@reduxjs/toolkit'
import { graphsReducer } from "./graphs";

export const store = configureStore({
  reducer: {
    graphs: graphsReducer,
  },

}); 